<template>
  <div>
    <app-centered-column>
      <zmanim-navigation />
      <app-jumbotron>
        <div slot="content">
          <app-jumbotron-banner />
        </div>
      </app-jumbotron>
      <div />
    </app-centered-column>
    <zmanim-footer />
  </div>
</template>

<script>
import AppCenteredColumn from './AppCenteredColumn'
import AppJumbotron from './AppJumbotron'
import AppJumbotronBanner from './AppJumbotronBanner'
import ZmanimNavigation from './ZmanimNavigation'
import ZmanimFooter from './ZmanimFooter'

export default {
  name: 'Faq',
  components: {
    AppCenteredColumn,
    AppJumbotron,
    AppJumbotronBanner,
    ZmanimNavigation,
    ZmanimFooter
  }
}
</script>

<style scoped>
/** Hide screenshot */
div >>> .app-jumbotron__screenshot-container {
  display: none;
}
</style>
